export default "__VITE_ASSET__CNLPg5H6__"